import { isRecord } from '../common/is-record';
import type { PromptOfTheDayPrompt } from '../types';

const parseNonEmptyString = (value: unknown): string | null => {
	if (typeof value !== 'string') {
		return null;
	}

	const trimmed = value.trim();
	return trimmed === '' ? null : trimmed;
};

const parseSources = (value: unknown): readonly string[] | undefined => {
	if (!Array.isArray(value)) {
		return undefined;
	}

	const sources = value
		.map(parseNonEmptyString)
		.filter((source): source is string => source !== null);
	return sources.length > 0 ? sources : undefined;
};

const parsePrompt = (value: unknown): PromptOfTheDayPrompt | null => {
	if (!isRecord(value)) {
		return null;
	}

	const shortPrompt = parseNonEmptyString(value.shortPrompt);
	if (shortPrompt === null) {
		return null;
	}

	const title = parseNonEmptyString(value.title);
	const expandedPrompt = parseNonEmptyString(value.expandedPrompt);
	const sources = parseSources(value.sources);

	return {
		shortPrompt,
		...(title !== null && { title }),
		...(expandedPrompt !== null && { expandedPrompt }),
		...(sources !== undefined && { sources }),
	};
};

export const parsePromptsFromOutput = (output: unknown): readonly PromptOfTheDayPrompt[] | null => {
	if (!isRecord(output) || !Array.isArray(output.prompts)) {
		return null;
	}

	const prompts = output.prompts.map(parsePrompt);
	return prompts.length > 0 && prompts.every((prompt) => prompt !== null)
		? (prompts as readonly PromptOfTheDayPrompt[])
		: null;
};
